import { routes } from "frontend/api/application";
import { requestGenericSettings } from "frontend/api/application/settings/request-generic-settings";
import { ReminderRaw } from "frontend/interfaces/settings/reminder";

export const api = requestGenericSettings<ReminderRaw>({
  endpoints: {
    indexEndpoint: routes.paths.frontend_settings_reminders_path,
    showEndpoint: routes.paths.frontend_settings_reminder_path,
  },
});
